import * as React from 'react';
import { Checkmark } from '@kvika/icons';
import { StyledCircle, StyledCircleContainer, StyledStepContainer, StyledTextContainer } from './styles/StepStyles';
export var StepState;
(function (StepState) {
    StepState[StepState["COMPLETE"] = 0] = "COMPLETE";
    StepState[StepState["CURRENT"] = 1] = "CURRENT";
    StepState[StepState["NEXT"] = 2] = "NEXT";
})(StepState || (StepState = {}));
var Step = function (_a) {
    var stepType = _a.stepType, number = _a.number, index = _a.index, label = _a.label;
    var renderCircle = function () {
        return stepType === StepState.COMPLETE ? (React.createElement(StyledCircle, { step: stepType },
            React.createElement(Checkmark, null))) : (React.createElement(StyledCircle, { step: stepType }, number));
    };
    return (React.createElement(StyledStepContainer, { "data-testid": "step-".concat(index) },
        React.createElement(StyledCircleContainer, { "data-testid": "circle-".concat(index), step: stepType }, renderCircle()),
        React.createElement(StyledTextContainer, { "data-testid": "text-".concat(index), step: stepType }, label)));
};
export default Step;
//# sourceMappingURL=Step.js.map